import React, { useEffect, useState } from 'react'
import ComponentInView from '@boltui/component-in-view'
import { gethostPath } from '../../helpers/ContentHelper'
import PromotionPanel from '../PromotionPanel/PromotionPanel'

const FeaturedProducts = () => {
  const [deliveryData, setDeliveryData] = useState()
  const [productsData, setProductsData] = useState()
  const [gettingData, nowGettingData] = useState(false)

  const featuredProductsData = {
    error: false,
    loading: !productsData,
    products: productsData,
    pageBeacon: deliveryData && deliveryData.PageBeacon,
  }

  useEffect(() => {
    // deliveryData
    const AMCV_MATCH = /AMCV_[0-9A-Z\%]+AdobeOrg=([0-9a-zA-Z\%\-\_]+)/g.exec(document.cookie) // eslint-disable-line
    const S_VI_MATCH = /s_vi=([0-9a-zA-Z\%\-\|\[\]]+)/g.exec(document.cookie) // eslint-disable-line
    const matchMedia = global.window && window.matchMedia
    const USER_ID = S_VI_MATCH ? S_VI_MATCH[1] : AMCV_MATCH ? AMCV_MATCH[1] : null
    const SUITE = matchMedia('only screen and (max-width: 700px)').matches ? 'mobile' : 'web'

    const URL =
      `${gethostPath()}global-api/homepage/products/api/taxonomy` +
      `?hlpt=H` +
      `&puserid=${USER_ID}` +
      `&platform=${SUITE}` +
      `&creative=150x150_M-C-OG_TI-1_4_Home` +
      `&taxonomy=home` +
      `&minmes=4&maxmes=16` +
      '&apiKey=D3B53863-2511-4DCE-9CD6-DE1F7C02201A' +
      '&beacon=individual' +
      '&verbosity=min'

    const fetchDeliveryData = async () => {
      let resData
      const res = await fetch(URL)
      try {
        resData = await res.json()
        setDeliveryData(resData)
      } catch (err) {
        resData = {}
      }
    }
    fetchDeliveryData()
  }, [])

  // products
  const getProducts = deliveryData && deliveryData.ProductAd && typeof productsData === 'undefined'

  const fetchProductData = async () => {
    const featuredSKUs = deliveryData.ProductAd.map((product) => product.ProductSKU)
    Promise.all(featuredSKUs.map((product) => fetch(`${gethostPath()}global-api/products/partNumber=${product}`)))
      .then((groupedResponse) =>
        Promise.all(groupedResponse.map((response) => response.json().then((dataTest) => dataTest.data.data))),
      )
      .then((finalData) => {
        const critProds = deliveryData.ProductAd
        const data = []
        finalData.forEach((argosProd, index) => {
          data.push({
            ...argosProd,
            attributes: {
              ...{ ...argosProd.attributes },
              ...{ tracking: critProds[index] },
            },
          })
        })
        setProductsData(data)
      })
      .catch((error) => console.log(error))
  }

  const getData = () => {
    if (!gettingData) {
      nowGettingData(true)
      fetchProductData()
    }
  }

  return (
    <ComponentInView offsetTop={500} onEnter={() => getProducts && getData()} onLeave={() => {}}>
      <PromotionPanel
        data={featuredProductsData}
        title={"We think you'll like..."}
        tracking={{ eventName: 'hp_recommendationsViewed', eventAction: 'Recommendations Viewed' }}
        source={'monetisation'}
        section={'middleSlider'}
      />
    </ComponentInView>
  )
}

export default FeaturedProducts
